module.exports = __webpack_public_path__ + "img/engineer_homepage.023542bc.png";